import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';

const AudioRecorder = observer(class AudioRecorder extends React.Component {
  constructor() {
    super();
    this.restart = this.restart.bind(this);
  }

  componentWillMount() {
    this.state = {
      showRecord: true,
      showStop: false,
      audioSrc: null
    }
  }

  componentDidMount() {
    const _this = this;
    const recordBtn = document.querySelector('.recorder__start');
    const stopBtn = document.querySelector('.recorder__stop');
    const canvas = document.querySelector('.recorder__visualizer');
    const constraints = {audio: true};
    let chunks = [];

    // Visualizer setup
    const audioCtx = new (window.AudioContext)();
    const canvasCtx = canvas.getContext('2d');

    // Audio recording
    navigator.mediaDevices.getUserMedia(constraints)
      .then(function(stream) {
        const mediaRecorder = new window.MediaRecorder(stream);

        visualize(stream);

        recordBtn.onclick = function() {
          _this.props.startRecording();
          mediaRecorder.start();
          _this.setState({
            showRecord: false,
            showStop: true
          });
        }

        stopBtn.onclick = function() {
          mediaRecorder.stop();
          _this.setState({
            showStop: false
          });
        }

        mediaRecorder.addEventListener('stop', function(){
          const blob = new Blob(chunks, {'type': 'audio/ogg; codecs=opus'});
          const audioUrl = window.URL.createObjectURL(blob);

          _this.setState({
            audioSrc: audioUrl
          });

          _this.props.setRecording(audioUrl);
        });

        mediaRecorder.ondataavailable = function(e) {
          chunks.push(e.data);
        }
      });

    // Visualizer
    function visualize(stream) {
      const source = audioCtx.createMediaStreamSource(stream);

      const analyser = audioCtx.createAnalyser();
      analyser.fftSize = 2048;
      const bufferLength = analyser.frequencyBinCount;
      const dataArray = new Uint8Array(bufferLength);

      source.connect(analyser);

      const WIDTH = canvas.width;
      const HEIGHT = canvas.height;

      draw();

      function draw() {
        requestAnimationFrame(draw);

        analyser.getByteTimeDomainData(dataArray);

        canvasCtx.fillStyle = '#f3f7f9';
        canvasCtx.fillRect(0, 0, WIDTH, HEIGHT);

        canvasCtx.lineWidth = 2;
        canvasCtx.strokeStyle = '#76838f';

        canvasCtx.beginPath();

        const sliceWidth = WIDTH * 1.0 / bufferLength;
        let x = 0;

        for(let i = 0; i < bufferLength; i++) {
          const v = dataArray[i] / 128.0;
          const y = v * HEIGHT/2;

          if(i === 0) {
            canvasCtx.moveTo(x, y);
          } else {
            canvasCtx.lineTo(x, y);
          }

          x += sliceWidth;
        }

        canvasCtx.lineTo(canvas.width, canvas.height/2);
        canvasCtx.stroke();
      }
    }
  }

  restart() {
    this.setState({
      showRecord: true,
      audioSrc: null
    });

    this.props.removeRecording();
  }

  render() {
    const { translation } = this.props;

    return(
      <div className="recorder">
        <canvas className={`recorder__visualizer ${this.state.showStop ? 'show' : 'hide'}`}></canvas>

        <button className="btn recorder__start" disabled={!this.state.showRecord} onClick={this.start}><icons.iconMicrophone />{translation.button}</button>
        <button className="btn btn--negative recorder__stop" disabled={!this.state.showStop} onClick={this.stop}><icons.iconStop />{translation.stop_button}</button>

        {this.state.audioSrc &&
          <div>
            <audio className="recorder__audio" controls src={this.state.audioSrc}></audio>
            <button className="btn btn--outline recorder__delete" onClick={this.restart}>{translation.restart_button}</button>
          </div>
        }
      </div>
    )
  }
})

export default translate('AudioRecorder')(AudioRecorder);


// WEBPACK FOOTER //
// ./src/app/components/AudioRecorder/AudioRecorder.js